<!---- Static Navbar start -->
<div class="header-bar">
  <div class="navbar navbar-custom">
    <a class="navbar-brand logomain mt-2" id="hidetxt"
      ><img
        src="assets/images/logotxt.svg"
        height="33"
        class="logo ml-3 logotextClick" /><img
        src="assets/images/logotxt.svg"
        width="150"
        class="logo1 sectpad logotextClick"
    /></a>
  </div>
  <div class="col-12 text-center webview">
    <!-- <img src="assets/images/eva-icons.svg" class="signimg1 prescsimg" /> -->
  </div>
</div>
<!---- Static Navbar end -->
<main role="main" class="maincntq">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
        <div class="col-sm-12 p-0 mt-5">
          <h1 class="text-center ssnHeadTxt">Let’s try this again!</h1>
          <div class="col-lg-4 col-md-6 m-auto">
            <span class="ssnTxt d-inline-block mt-3">
              Thanks for taking care of that! For security purposes, we have
              saved your responses and logged you out.
            </span>
            <!-- <span class="ssnTxt d-inline-block mt-3"
              >Now that you have successfully managed your credit proﬁle online,
              in order to re-run your credit and complete signing up for this
              plan (or to ask any questions), please contact:
            </span>
            <div class="ssnenergyTxt text-center">
              <p class="fntbold mb-0 mt-2">
                {{ selectedProduct.energy_provider }}
              </p>

              <p class="mb-1">
                {{
                  providerContact != undefined && providerContact.working_hours
                    ? providerContact.working_hours
                    : ''
                }}
              </p>
              <p class="fntbold clrblue">
                <a
                  [href]="'tel:' + providerContact.customerDeposit_enquiry"
                  class="clrblue"
                  >{{
                    providerContact != undefined &&
                    providerContact.customerDeposit_enquiry
                      ? providerContact.customerDeposit_enquiry
                      : ''
                  }}</a
                >
              </p>
            </div> -->
            <br /><br />
            <span class="ssnTxt text-left d-inline-block">
              Please log back in using the same method as before to continue.
              Just a heads up, you will be asked to verify some info so that we
              can re-process your enrollment.
            </span>
          </div>
          <div class="getbannersect pb-2">
            <!-- <h1 class="text-center headfont loginmrgn signuppadd mobileview" style="font-size: 34px !important">Login to your account</h1> -->
            <div class="sectpad container">
              <div class="col-sm-12 p-0 signupmobile">
                <a _ngcontent-c5="" class="mobclose" href="javascript:void(0);"
                  ><img
                    _ngcontent-c5=""
                    src="assets/images/mobclose.png"
                    (click)="closebtn()"
                /></a>
                <!-- <h1 class="text-center headfont loginmrgn signuppadd webview">Login to your account</h1> -->
                <div
                  class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto my-5 py-3 text-center"
                >
                  <!-- <a title="Sign up with Facebook" href="{{url}}/auth/facebook" class="btn btn-facebook col-sm-12 p-1 boxcolour sgoptpad mbfbbox"> -->
                  <a
                    title="Sign up with Facebook"
                    href="javascript:void(0);"
                    (click)="getAuthenticate('/auth/facebook')"
                    class="btn btn-facebook pt-1 pb-1 boxcolour sgoptpad minvalue fbNewBtn"
                  >
                    <div class="img-bdr text-center boxcolour">
                      <span class="faceicon">
                        <img
                          src="assets/images/facebook-ronded.svg"
                          width="30"
                        />
                      </span>
                      <span
                        class="pl-2 fntwgtvle sgopt mbtxtbox color-gray font-calibre-regular"
                        >Continue with Facebook</span
                      >
                    </div>
                  </a>
                </div>

                <div
                  class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center"
                >
                  <!-- <a title="Sign up with Gmail" href="{{url}}/auth/google" class="btn btn-google p-1 col-sm-12 p-0 boxcolour sgoptpad mbfbbox"> -->
                  <a
                    title="Sign up with Gmail"
                    href="javascript:void(0);"
                    (click)="getAuthenticate('/auth/google')"
                    class="btn btn-google pt-1 pb-1 boxcolour sgoptpad minvalue fbNewBtn"
                  >
                    <div class="img-bdr text-center boxcolour">
                      <span class="googleicon">
                        <img src="assets/images/gmail.svg" width="30" />
                      </span>
                      <span
                        class="pl-2 fntwgtvle sgopt mbtxtbox color-gray font-calibre-regular"
                        >Continue with Google
                      </span>
                    </div>
                  </a>
                </div>
                <div
                  class="col-lg-4 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center px-3"
                >
                  <div class="login-or" style="margin-top: 1.5rem !important">
                    <hr class="hr-or" />
                    <span class="span-or">or</span>
                  </div>
                </div>
                <div class="container" style="margin-top: 1rem !important">
                  <div class="row">
                    <div class="text-center pt-3 minvalue m-auto">
                      <form
                        name="form"
                        (ngSubmit)="createAccount($event, f)"
                        #f="ngForm"
                        novalidate
                      >
                        <div class="text-center minvalue m-auto">
                          <div class="form-group float-label-control">
                            <label for="email">Email/Phone Number</label>
                            <input
                              type="text"
                              class="form-control inputshadow"
                              name="email"
                              [(ngModel)]="userObj.emailId"
                              #email="ngModel"
                              [ngClass]="{
                                'is-invalid': f.submitted && email.invalid
                              }"
                              required
                              email
                            />
                            <div
                              *ngIf="f.submitted && email.invalid"
                              class="invalid-feedback"
                            >
                              <div
                                class="posabs font15"
                                *ngIf="email.errors.required"
                              >
                                Email/Phone number is required
                              </div>
                            </div>
                          </div>
                          <div class="form-group float-label-control mb-0">
                            <label for="password">Password</label>
                            <input
                              type="password"
                              class="form-control inputshadow"
                              name="password"
                              [(ngModel)]="userObj.password"
                              #password="ngModel"
                              [ngClass]="{
                                'is-invalid': f.submitted && password.invalid
                              }"
                              required
                            />
                            <div
                              *ngIf="f.submitted && password.invalid"
                              class="invalid-feedback"
                            >
                              <div
                                class="posabs font15"
                                *ngIf="password.errors.required"
                              >
                                Password is required
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-left minvalue m-auto">
                          <a
                            class="forgbtn font18"
                            href="javascript:void(0)"
                            data-toggle="modal"
                            data-target="#forgotModal"
                            (click)="showForgotModal()"
                          >
                            forgot password?</a
                          >
                        </div>
                        <div class="minvalue text-center">
                          <button class="btn sectbtn signinpad mt-4 minvalue">
                            LOGIN
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- <app-forgot-password
  [forgotVisible]="forgotModalVisible"
  (closeForgotModalEvent)="onClose($event)"
></app-forgot-password> -->
